import React from "react";
import { Upload, Image, Button, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import type { SetStateAction } from "react";
import { EntPhoto } from "features/serviceCategory/model/serviceCategory";

type Props = {
  existingPhotos: EntPhoto[];
  setExistingPhotos: (value: SetStateAction<EntPhoto[]>) => void;

  fileList: UploadFile[];
  setFileList: (files: UploadFile[]) => void;

  deletedPhotoIds: string[];
  setDeletedPhotoIds: (value: SetStateAction<string[]>) => void;

  maxFiles?: number;
};

export const PhotoUpload = ({
  existingPhotos,
  setExistingPhotos,
  fileList,
  setFileList,
  deletedPhotoIds,
  setDeletedPhotoIds,
  maxFiles = 1,
}: Props) => {
  const handleFileChange: UploadProps["onChange"] = ({ fileList }) => {
    const valid = fileList
      .filter(
        (f): f is UploadFile & { originFileObj: File } => !!f.originFileObj,
      )
      .map((f) => ({
        ...f,
        uid: f.uid || Math.random().toString(36).slice(2),
        status: "done" as const,
      }));

    if (valid.length + existingPhotos.length > maxFiles) {
      message.error(`Фотографий не может быть больше ${maxFiles}`);
      return;
    }

    // если maxFiles=1 — оставим только последний выбранный
    const next = maxFiles === 1 ? valid.slice(-1) : valid;
    setFileList(next);
  };

  const handleRemoveExistingPhoto = (photoId: string) => {
    // не добавляем повторно
    if (!deletedPhotoIds.includes(photoId)) {
      setDeletedPhotoIds((prev) => [...prev, photoId]);
    }
    setExistingPhotos((prev) => prev.filter((p) => p.id !== photoId));
  };

  return (
    <>
      {existingPhotos.length > 0 && (
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          {existingPhotos.map((p) => {
            if (!p.id) return null;
            const thumb = p.filePathThumb || p.filePath || "";
            const full = p.filePath || p.filePathThumb || "";

            return (
              <div key={p.id} style={{ position: "relative" }}>
                <Image
                  src={thumb}
                  width={100}
                  height={100}
                  style={{ objectFit: "cover" }}
                  preview={full ? { src: full } : false}
                />
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => handleRemoveExistingPhoto(p.id!)}
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    color: "red",
                  }}
                />
              </div>
            );
          })}
        </div>
      )}

      <Upload
        multiple={maxFiles > 1}
        beforeUpload={() => false}
        onChange={handleFileChange}
        fileList={fileList}
        listType="picture-card"
        accept="image/*"
        showUploadList={{
          showRemoveIcon: true,
          removeIcon: <DeleteOutlined />,
          showPreviewIcon: true,
        }}
      >
        {fileList.length + existingPhotos.length < maxFiles && (
          <div>
            <UploadOutlined />
            <div style={{ marginTop: 8 }}>Загрузить</div>
          </div>
        )}
      </Upload>
    </>
  );
};
